import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Api } from '../../services/api';
import { RegionService } from '../../services/region.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertService } from '../../services/alert.service';


@Component({
    standalone:true,
    selector: 'app-mdl-manage-opportunity',
    imports: [FormsModule,CommonModule, NgSelectModule],
    templateUrl: './mdl-manage-opportunity.html',
    styleUrls: ['./mdl-manage-opportunity.css']

})
export class MdlManageOportunity implements OnInit {
  private api = inject(Api);
  propietarioOportunidad: string = '';
  oportunidades: any[] = [];
  public contactos : any[]=[]
  oportunidadSeleccionada: any = null;
  public today: string = '';
  private alertService = inject(AlertService);



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlManageOportunity>
  ) {}

  public oportunidad: any = {};
  public selectedAccount: any = null;
  public request: any = {
    nombre: '',
    cuenta_id: '',
    contacto_id:'',
    tipo_negocio: '',
    id_estado: '',
    importe_antes:0 ,
    importe_actual:0,
    fecha_cierre: '',
    probabilidad_cierre: 0,
    sgte_paso: '',
    propietario: 'Juan Soto', 
    categoria_prevision: '',
    tipo_oportunidad: '',
    motivo_perdida: '',
    descripcion: '',
    contrato: '',
    presupuesto: '',
    tipo_empresa: '',
    fuente_lead: '',
    notas: '' ,
    estado: '',
    privada_publica:'',
    presupuesto_sincronizado: '',
    marcado: 0,
  };

  public accounts: any = []; 
  public estados: any = [];


  ngOnInit(): void {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    this.today = `${year}-${month}-${day}`;

    console.log('Data recibida del modal anterior:', this.data);
    this.getOpportunityEstados();
    
    this.getAccounts();
    if (this.data.mode === 'edit') {
      this.oportunidad = this.data.oportunidad;
      this.selectedAccount = this.oportunidad.cuenta_id;
      console.log(this.data.oportunidad);
      this.request = { ...this.request, ...this.oportunidad };
    } else {
      this.request.tipo_empresa = this.data.tipo_empresa;
    }

    this.api.getOpportunities().subscribe((response: any) => {
      if (Array.isArray(response.oportunidades)) {
        this.oportunidades = response.oportunidades;
      } else {
        console.error('getOpportunities no retornó un array:', response.oportunidades);
      }
    })

    if (this.data.mode === 'edit') {
      this.oportunidad = this.data.oportunidad;
      this.request.cuenta_id = this.oportunidad.cuenta_id;
      this.request.nombre = this.oportunidad.nombre;
      this.request.tipo_negocio = this.oportunidad.tipo_negocio;
      this.request.id_estado = this.oportunidad.id_estado;
      this.request.importe = this.oportunidad.importe;
      this.request.fecha_cierre_estimada = this.oportunidad.fecha_cierre_estimada;
      this.request.probabilidad = this.oportunidad.probabilidad;
      this.request.siguiente_paso = this.oportunidad.siguiente_paso;
      this.request.propietario = this.oportunidad.propietario;
      this.request.categoria_prevision = this.oportunidad.categoria_prevision;
      this.request.tipo_oportunidad = this.oportunidad.tipo_oportunidad;
      this.request.motivo_perdida = this.oportunidad.motivo_perdida;
      this.request.descripcion = this.oportunidad.descripcion;
      this.request.contrato = this.oportunidad.contrato;
      this.request.presupuesto = this.oportunidad.presupuesto;
      this.request.tipo_empresa = this.oportunidad.tipo_empresa;
      this.request.probabilidad_cierre = this.oportunidad.probabilidad_cierre;
      this.request.privada_publica = this.oportunidad.tipo_empresa;
      this.request.presupuesto_sincronizado = this.oportunidad.presupuesto_sincronizado;
    }else{
      this.request.privada_publica = this.data.privada_publica;
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  updateOpportunity() {
    this.api.showLoading();
    try{
      this.api.updateOpportunity(this.request).subscribe({
        next:(data:any) =>{
            setTimeout(() => {
                this.api.hideLoading();
                window.location.reload();
            }, 500);
        },
        error: (err:any) => {
          this.api.hideLoading();
          if (err?.status===403){
            this.alertService.error('Acceso denegado','No tienes permiso para editar oportunidades')
            this.mdl.close(false);
            return
          }
          this.alertService.error('Error','Ocurrio un problema inesperado al actualizar la oportunidad')
        }
      });
    } catch (err) {
        console.error(err);
    }
  }

  createOpportunity(){
    this.request.oportunidad_id = this.oportunidadSeleccionada;
    this.request.cuenta_id = this.selectedAccount;
    this.api.showLoading();
    try {
      this.api.createOpportunity(this.request).subscribe({
        next: (data:any) => {
            setTimeout(() => {
                this.api.hideLoading();
                window.location.reload();
            }, 500);
        },
        error: (error:any) => {
          this.api.hideLoading();
          if (error?.status===403){
            this.alertService.error('Acceso denegado','No tienes permiso para crear oportunidades')
            this.mdl.close(false);
            return
          }
          this.alertService.error('Error','Ocurrio un problema al crear la oportunidad')
          this.mdl.close(false)
        }
      });
    } catch (err) {
        console.error(err);
    }
  }

  getAccounts(){
    try {
      this.api.getAccounts().subscribe({
        next:(data:any) =>{
          this.accounts = data.cuentas;
        },
        error: (error:any)=>{
          console.error(error);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  getOpportunityEstados(){
    this.api.getStatusByType({tipo:"OPP"}).subscribe({
      next: (resp: any) => {
        this.estados = resp.data;
        if(this.data.mode === "create"){
          const defaultStatus = this.estados?.find((estado: any) => estado.orden === 1);
          if (defaultStatus && !this.request.id_estado) {
            this.request.id_estado = defaultStatus.id_estado;
          }
        }
      },
      error: (err: any) => {
        console.error('Error al obtener los estados de prospecto:', err);
      }
    });
  }

  actualizarPropietario(cuenta_id: string){
    this.propietarioOportunidad = 'Sin propietario';
    this.getContactsByAccount(cuenta_id);
  }

  

  getContactsByAccount(cuentaId: string) {
    if (!cuentaId) {
      this.contactos = [];
      this.request.contacto_id = '';
      return;
    }
  
    this.api.getcontactsbycuenta(cuentaId).subscribe({
      next: (data: any) => {
        this.contactos = data.contactos || [];
        this.request.contacto_id = '';
      },
      error: (error: any) => {
        console.error(error);
        this.contactos = [];
        this.request.contacto_id = '';
      }
    });
  }
  
  actualizarPropietarioContacto(contacto_id: string) {
    const contacto = this.contactos.find((c: any) => c.contacto_id === contacto_id);
    const ejecutivo = contacto?.ejecutivo;
    this.propietarioOportunidad = ejecutivo
      ? `${ejecutivo.nombre} ${ejecutivo.apellido}`
      : 'Sin propietario';
  }
  

}